import { fetch } from '@nackle/umbrella';
import { kadhavuExpUrl } from 'endpoints';
import { startLoading, endLoading, setError } from './app-dux';

/*******************************************************************************
 * Initial state
 */
const initialState = {
    recoveryMethods: {
        email: [],
        phone: []
    },
    username: ''
};

/*******************************************************************************
 * Non-async action types
 */
export const SET_RECOVERY = 'state/set_recovery';
export const CLEAR_RECOVERY = 'state/clear_recovery';
export const SET_RECOVERY_METHODS = 'state/set_recovery_methods';

/*******************************************************************************
 * Reducer
 */
export default function recoveryReducer( state = initialState, action ) {
    switch ( action.type ) {
        case SET_RECOVERY: {
            return {
                ...state,
                recovery: action.recovery
            };
        }
        case CLEAR_RECOVERY: {
            return {
                ...state,
                recoveryMethods: {
                    email: [],
                    phone: []
                }
            };
        }
        case SET_RECOVERY_METHODS: {
            return {
                ...state,
                recoveryMethods: {
                    email: action.email,
                    phone: action.phone
                },
                username: action.username
            };
        }
        default:
            return state;
    }
}

/*******************************************************************************
 * Action creators
 */


export function getContacts( username ) {
    return ( dispatch )=> {
        dispatch( startLoading() );
        return fetch( `${ kadhavuExpUrl }/getPerson`, {
            method: 'POST',
            headers: { 'content-type': 'application/json' },
            body: JSON.stringify(
                {
                    username: username,
                    properites: { 
                        distinctAddresses: true 
                    }
                }
            )
        } ) .then( ( res ) => {
            if ( res.ok ) {
                return res.json().then( ( data ) => {
                    if ( data && !data.errors && data.success ) {
                        delete data.success;
                        dispatch( setContactMethods( data, username ) );
                    } else if ( data.errors ) {
                        const errors = [];
                        data.errors.forEach( error => {
                            if ( error.code === 'kadhavu.error.invalidEntry' ) {
                                errors.push( { code: 'recoveryInfo.error.invalidEntry' } );
                            } else if ( error.code === 'kadhavu.error.genericTwo' ) {
                                errors.push( { code: 'recoveryInfo.error.genericTwo' } );
                            } else if ( error.code === 'kadhavu.error.terminatedWithNoPoints' ) {
                                errors.push( { code: 'kadhavu.error.terminatedWithNoPoints' } );
                            } else {
                                errors.push( { code: 'recoveryInfo.error.unknownError' } );
                            }
                        } );

                        dispatch( setError( errors ) );
                    }
                    dispatch( endLoading() );
                } );
            } else {
                return res.json().then( ( data ) => {
                    dispatch( setError( [ { code: 'recoveryInfo.error.unknownError' } ] ) );
                    dispatch( endLoading() );
                } );
            }
        } )
        .catch ( ( err ) => {
            dispatch( setError( [ { code: 'recoveryInfo.error.unknownError' } ] ) );
            dispatch( endLoading() );
        } );
    };
}

export function getContactsByEmailAddress( emailAddress ) {
    return ( dispatch )=> {
        dispatch( startLoading() );
        return fetch( `${ kadhavuExpUrl }/searchPersons`, {
            method: 'POST',
            headers: { 'content-type': 'application/json' },
            body: JSON.stringify(
                {
                    address: emailAddress
                }
            )
        } ) .then( ( res ) => {
            if ( res.ok ) {
                return res.json().then( ( data ) => {
                    const errors = [];
                    if ( data && data.distinctAddresses && !data.errors ) {
                        delete data.success;
                        const searchedPersons = data || {};
                        if ( !searchedPersons.isPersonUnique ) {
                            errors.push( { code: 'methodOfContact.error.nonuniqueEmailAddress' } );
                        } else if ( !searchedPersons.isPersonActivated ) {
                            errors.push( { code: 'methodOfContact.error.unactivatedAccount', data: { activationLink: '/door/activate' } } );
                        } else if ( !searchedPersons.distinctAddresses.length ) {
                            errors.push( { code: 'recoveryInfo.error.invalidEntry' } );
                        } else {
                            dispatch( setContactMethods( searchedPersons ) );
                        }

                        if ( errors.length ) {
                            dispatch( setError( errors ) );
                        }
                    } else if ( data.errors ) {
                        const errors = [];
                        data.errors.forEach( error => {
                            if ( error.code === 'kadhavu.error.invalidEntry' || error.code === 'kadhavu.error.invalidContactMethod' ) {
                                errors.push( { code: 'recoveryInfo.error.invalidEntry' } );
                            } else if ( error.code === 'kadhavu.error.genericTwo' ) {
                                errors.push( { code: 'recoveryInfo.error.genericTwo' } );
                            } else {
                                errors.push( { code: 'recoveryInfo.error.unknownError' } );
                            }
                        } );

                        dispatch( setError( errors ) );
                    }
                    dispatch( endLoading() );
                } );
            } else {
                return res.json().then( ( data ) => {
                    dispatch( setError( [ { code: 'recoveryInfo.error.unknownError' } ] ) );
                    dispatch( endLoading() );
                } );
            }
        } )
            .catch ( ( err ) => {
                dispatch( setError( [ { code: 'recoveryInfo.error.unknownError' } ] ) );
                dispatch( endLoading() );
            } );
    };
}

export function setRecoveryMethods( methods, redirectUrl, accessToken ) {
    return ( dispatch, getState ) => {
        const state = getState();
        dispatch( startLoading() );
        return fetch( `${ kadhavuExpUrl }/setRecoveryMethods`, {
            method: 'POST',
            headers: {
                'content-type': 'application/json',
                'authorization': `Bearer ${ accessToken }`
            },
            body: JSON.stringify(
                {
                    recoveryMethods: methods, locale: state.app.userSelectedLocale || ''
                }
            )
        } )
        .then( ( res ) => {
            if ( res.ok ) {
                return res.json().then( ( data ) => {
                    if ( data && !data.errors ) {
                        dispatch( endLoading() );
                        window.location.assign( redirectUrl );
                    } else if ( data.errors ) {
                        const errors = [];
                        data.errors.forEach( error => {
                            if ( error.code === 'kadhavu.error.nonUniqueEmailRecoveryMethodsFailure' ) {
                                errors.push( { code: 'recoveryInfo.error.nonUniqueEmailRecoveryMethods' } );
                            } else {
                                errors.push( { code: 'recoveryInfo.error.unknownError' } );
                            }
                        } );

                        dispatch( setError( errors ) );
                    }
                    dispatch( endLoading() );
                } );
            } else {
                return res.json().then( ( data ) => {
                    dispatch( setError( [ { code: 'recoveryInfo.error.unknownError' } ] ) );
                    dispatch( endLoading() );
                } );
            }
        } )
        .catch ( ( err ) => {
            dispatch( setError( [ { code: 'recoveryInfo.error.unknownError' } ] ) );
            dispatch( endLoading() );
        } );
    };
}

export function setRecovery( recovery ) {
    return {
        type: SET_RECOVERY,
        recovery
    };
}

export function clearRecoveryMethods() {
    return {
        type: CLEAR_RECOVERY
    };
}
export function setContactMethods( person, username ) {
    const email = [];
    const phone = [];
    if ( person && person.distinctAddresses ) {
        const emails = person.distinctAddresses.filter( address => {
            return address.method === 'emailAddress';
        } );
        email.push( ...emails );
        const phones = person.distinctAddresses.filter( address => {
            return address.method === 'phoneNumber';
        } );
        phone.push( ...phones );
    }
    sessionStorage.setItem( 'recoveryMethods', JSON.stringify( { email: email, phone: phone } ) );
     return {
         type: SET_RECOVERY_METHODS,
         email: email,
         phone: phone,
         username: username
    };
}